import React from 'react';
import styled from 'styled-components';
import { Button } from '../../UI/Buttons';
import { Overlay, Modal as UIModal } from '../../UI/Containers';

const ModalContent = styled(UIModal)`
  max-width: 500px;
  width: 90%;
  position: relative;
  padding: ${({ theme }) => theme.spacing.lg};
`;

const CloseButton = styled(Button)`
  position: absolute;
  top: ${({ theme }) => theme.spacing.sm};
  right: ${({ theme }) => theme.spacing.sm};
  background: none;
  border: none;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  padding: 0;
  line-height: 1;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    background: none;
  }
`;

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  // Prevent clicks inside the modal from closing it
  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <Overlay opacity={0.6} onClick={onClose}>
      <ModalContent onClick={handleContentClick}>
        <CloseButton onClick={onClose} aria-label="Close">&times;</CloseButton>
        {children}
      </ModalContent>
    </Overlay>
  );
};

export default Modal;
